<template>
	<div class="m_container" :class="openType != 'mob' ? 'flex_center flex_items vh100' : ''">
		<div class="content plr20 bgfff" style="box-sizing: border-box;"
			:class="openType != 'mob' ? 'container_w_h vh100' : ''"
			:style="openType != 'mob' ? 'overflow-y:auto' : 'min-height:100vh'">
			<div class="pt20">
				<div class="mb20 bold">会员</div>
				<div class="flex flex_warp flex_items ">
					<div class="pb10 list-content pt10 mb20 pointer" @click="handleClick(item,0)" :class="item.click ? 'click' : ''"
						v-for="(item, index) in userList" :key="index">
						{{item.name}}
					</div>
				</div>
			</div>
			<div class="mt20">
				<div class="mb20 bold">工作人员</div>
				<div class="flex flex_warp flex_items">
					<div class="pb10 list-content pt10 mb20 pointer" @click="handleClick(item,1)" :class="item.click ? 'click' : ''"
						v-for="(item, index) in offList" :key="index">
						{{item.name}}
					</div>
				</div>
			</div>
			<div class="empty" v-if="allUser.length == 0">暂无数据</div>
		</div>
		<div class="bottom_btn bottom_btn" @click="submit">
			<div class="btn_contenbt mr10">设置</div>
		</div>
	</div>
</template>

<script>
	import {
		openType
	} from '@/utils/tool.js'
	export default {
		data() {
			return {
				list: [],
				id: '',
				userList: [],
				offList:[],
				allUser:[],
				openType: openType(),
			}
		},
		methods: {
			getlist() {
				this.api.projectUser({}, this.id).then(res => {
					res.data.map(r => {
						this.list.push(Number(r.id))
					})
					this.getAllUser()
				})
			},
			handleClick(item) {
				if (this.list.indexOf(item.id) >= 0) {
					item.click = false;
					this.list.splice(this.list.indexOf(item.id), 1)
				} else {
					this.list.push(item.id);
					item.click = true
				}
				this.$forceUpdate()
			},
			getAllUser() {
				this.api.accountList({
					type: 'project'
				}).then(res => {
					this.allUser = res.data;
					this.userList = [];
					this.offList = [];
					res.data.map(r => {
						if(r.role == 'member'){
							this.userList.push(r)
						}
						if(r.role == 'officer'){
							this.offList.push(r)
						}
					})
					
					
					if (this.list.length != 0) {
						this.list.map(r => {
							for (let i = 0; i < this.userList.length; i++) {
								if (this.userList[i].id == r) {
									this.userList[i].click = true;
									break
								}
							}
							for (let i = 0; i < this.offList.length; i++) {
								if (this.offList[i].id == r) {
									this.offList[i].click = true;
									break
								}
							}
						})
					}
				})
			},
			submit() {
				this.api.projectSet({
					users: JSON.stringify(this.list)
				}, this.id).then(res => {
					this.Toast('设置成功')
					setTimeout(() => {
						window.history.go(-1)
					}, 1500)
				}).catch(() => {})
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.getlist();
		}
	}
</script>

<style scoped="scoped">
	.list-content {
		border: 1px solid #ccc;
		border-radius: 10px;
		padding: 5px 10px;
		margin-right: 20px;
		color: #3d3d3d;
		background-color: #fff;
	}

	.list-content.click {
		background-color: #00D8CC;
		border: 1px solid #00D8CC;
		color: #fff;
	}
</style>
